import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { ScheduleStatus } from './types';
import type { IGetSchedulesResponse } from './types';

export const getSchedules = async (
  limit: string = '15',
  afterId?: string,
  status?: ScheduleStatus,
  scheduledFrom?: string,
  scheduledTo?: string,
): Promise<IGetSchedulesResponse> => {
  try {
    const urlWithParams = new URL(`${API_URL}/schedules?limit=${limit}`);

    if (status) {
      urlWithParams.searchParams.append('status', status);
    }

    if (afterId) {
      urlWithParams.searchParams.append('after_id', afterId);
    }

    if (scheduledFrom) {
      urlWithParams.searchParams.append('scheduled_from', scheduledFrom);
    }

    if (scheduledTo) {
      urlWithParams.searchParams.append('scheduled_to', scheduledTo);
    }

    const response = await fetch(urlWithParams.href);

    if (!response.ok) {
      throw new Error('We have been unable to complete your request. Please try again');
    }

    const json: IGetSchedulesResponse = await response.json();
    return json;
  } catch (e) {
    throw new Error(e);
  }
};
